export default __webpack_public_path__ + "static/media/garbage-3-frequency.e63983c7.svg";